import {z} from 'zod';

export const slackIntegrationStatusSchema = z.discriminatedUnion('connected', [
  z.object({
    provider: z.literal('slack'),
    connected: z.literal(false),
  }),
  z.object({
    provider: z.literal('slack'),
    connected: z.literal(true),
    teamId: z.string(),
    teamName: z.string(),
    connectedAt: z.string(),
  }),
]);

export type SlackIntegrationStatus = z.infer<
  typeof slackIntegrationStatusSchema
>;

export const slackOAuthAuthorizationSchema = z.object({
  authorizationUrl: z.string().url(),
});

export type SlackOAuthAuthorization = z.infer<
  typeof slackOAuthAuthorizationSchema
>;

export const slackChannelSchema = z.object({
  id: z.string(),
  name: z.string(),
  isPrivate: z.boolean(),
});

export type SlackChannel = z.infer<typeof slackChannelSchema>;

export const slackChannelsSchema = z.array(slackChannelSchema);
